import type { AuthorConfig } from '../models/map/author-config';

export const getRadiusOptions = (authorConfig: AuthorConfig): [number, number[]] => {
  const { initialSearchRadius } = authorConfig;

  if (initialSearchRadius) {
    const searchRadiusStringOptions = initialSearchRadius.split(/ ?, ?/);
    const initSearchRadius = Math.abs(Number(searchRadiusStringOptions[0]));
    const searchRadiusOptions = [
      ...new Set(
        searchRadiusStringOptions
          .map((option) => Math.abs(Number(option)))
          .filter((option) => option)
          .sort((a, b) => a - b),
      ),
    ];

    if (searchRadiusOptions.length === 0) return [10, [10]];

    return [initSearchRadius, searchRadiusOptions];
  }

  return [10, [10]];
};
